export default {
      id: "log-out-usage",
      viewBox: "0 0 12 14",
      url: __webpack_public_path__ + "sprite.svg#log-out-usage",
      toString: function () {
        return this.url;
      }
    }